module.exports = __webpack_public_path__ + "img/google.b63975ff.svg";